<template>
	<div>
		<b-modal ref="modalError"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<b-modal ref="loaderModal"
			hide-footer
			title="Chargement...">
			<throbber />
			<p class="my-4">{{ $t("Tooltip.message_wait") }}</p>
		</b-modal>
		<div class="col-12 mt-4">
			<div class="row">
				<div class="col-12 col-lg-7">
					<div class="embed-responsive embed-responsive-16by9" v-if="!hasCarouselVideo">
						<video class="embed-responsive-item"
							:src="(videoUrl !== null) ? videoUrl : infographicUrl"
							ref="videoplayer"
							controls>
						</video>
					</div>
				</div>
				<div class="col-12 col-lg-5">
					<div class="row">
						<label class="btn label btn-edition"
							style="margin-left:1rem;">{{ $t("Infographic.upload") }} <input type="file"
							id="file"
							ref="fileUpload"
							v-on:change="handleFileUpload()"
							hidden
							accept="image/*"> </label>
					</div>
					<div class="row mt-3">
						<div class="col-12">
							<form>
								<div class="form-group">
									<label class="title_label"
										for="title">{{ $t("Infographic.title") }}</label>
									<span class="modificationLabel"> {{ this.modificationTitle }} </span>
									<input type="text"
										class="form-control no-border"
										id="title"
										@change="setModificationTitleLabel"
										@input="setModificationTitleLabel"
										v-model="inputTitle"
										ref="inputTitle">
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 col-lg-3">
					<ValidStep :title="inputTitle"
						:imageName="imageName"
						:videoName="videoName"
						:id="id" />
				</div>
				<div class="col-12 col-lg-3">
					<div class="mt-4 ml-3">
						<a href="#"
							:class="[isSaved ? 'btn btn-cancel' : 'disabled btn btn-cancel']">{{ $t("Button.cancel") }}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ValidStep from "../ui/buttons/ValidStepInfographic";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";
import axios from "axios";
import {EventBus} from "../../event/event-bus";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "Infographic",
	components: {lottie_error, ValidStep, throbber},
	props: {
		id: Number,
		stepName: String,
		title: String,
		hasCarouselVideo: Boolean,
		hasVoiceOver: Boolean,
		hasMusicEnable: Boolean,
		infographic: Object,
		isVisible: Boolean,
		isCompleted: String,
		renderId: Number,
		video: Object,
		groupId: String,
		imageId: Number,
		projectId: Number,
	},
	data() {
		return {
			text_error: "",
			titleField: "",
			isSaved: false,
			imageName: "",
			videoName: "",
			modificationTitle: "",
		};
	},
	computed: {
		inputTitle: {
			get() {
				return this.titleField;
			},
			set(v) {
				this.titleField = v;
			},
		},
		videoUrl: {
			get() {
				if (this.video !== undefined) {
					return this.video.url;
				}
				else {
					return null;
				}
			},
			set(v) {
				this.video = v;
			},
		},
		infographicUrl: {
			get() {
				if (this.infographic !== undefined) {
					return this.infographic.url;
				}
				else {
					return "";
				}
			},
			set(v) {
				this.infographic = v;
			},
		},
	},
	activated() {
		this.getDatas(this.id);
	},
	created() {
		let $this = this;
		EventBus.$on("setStepInfographicComplete", id => {
			$this.getDatas(id);
		});
		EventBus.$on("setModificationTitleLabel", label => {
			$this.modificationTitle = label;
		});
	},
	methods: {
		getDatas(id) {
			let $this = this;

			axios.get(BASE_URL + "/public/api/stepInfographics/" + id, {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(response => {
				let data = response.data.data;
				$this.inputTitle = data.title || "";
				if (data.video !== undefined) {
					$this.videoUrl = data.video;
					$this.infographicUrl = null;
				}
				else {
					if (data.infographic !== undefined) {
						$this.videoUrl = data.infographic;
					}
					else {
						$this.videoUrl = "";
					}
				}
			}).catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		handleFileUpload() {
			let $this = this;
			let inputFiles = $this.$refs.fileUpload.files;
			this.isSaved = false;
			let bodyFormData = new FormData();
			if (this.inputTitle.length > 0) {
				bodyFormData.append("title", this.inputTitle);
			}
			if (inputFiles.length >= 1) {
				$this.$refs.loaderModal.show();
				if (inputFiles.length > 0) {
					bodyFormData.append("image", inputFiles[0]);
				}
				axios.post(BASE_URL + "/public/api/stepInfographics/" + this.id + "/previewStepCompil",
					bodyFormData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
							"Authorization": sessionStorage.getItem("auth"),
						},
					})
				.then(function (response) {
					let data = response.data;
					$this.videoUrl = data.infographic;
					$this.imageName = data.imageName;
					$this.videoName = data.videoName;
					$this.$refs.loaderModal.hide();
				}).catch(error => {
					$this.text_error = this.$root.$t("Errors.error_detailed") + e;
					$this.$refs.modalError.show();
				});
			}
		},
		setModificationTitleLabel() {
			this.modificationTitle = this.$root.$t("Button.editing");
		},
	},
};
</script>

<style scoped>
.label {
	background-color: #144B5E;
	color: #FFFFFF;
	margin-bottom: 1rem;
	margin-left: 15px;
	margin-right: 10px;
	padding: .375rem .5rem;
	cursor: pointer;
}

.title_label {
	font-size: 14px;
	color: #224B93;
}

.btn {
	margin-left: auto;
	border-radius: var(--small-border-radius);
}

input[type=file] {
	position: absolute;
	top: 0;
	right: 0;
	min-width: 100%;
	min-height: 100%;
	font-size: 100px;
	text-align: right;
	filter: alpha(opacity=0);
	opacity: 0;
	outline: none;
	background: white;
	cursor: inherit;
	display: block;
}

input {
	border-top: none;
	border-left: none;
	border-right: none;
	border-bottom: #224B93 solid 1px;
}

.btn-cancel {
	background-color: #D62B2B;
	border-color: #D62B2B;
	color: white;
}

.modificationLabel {
	font-size: 14px;
	color: orange;
}

.btn-edition {
	background-color: var(--color-secondary-action);
	border-color: var(--color-secondary-action);
	cursor: pointer;
	color: var(--text-secondary-action);
	margin-bottom: 6px;
}
</style>
